<template>
  <div class="esls-page">
    <div class="public-breadcrumb">
      <router-link style="color: #6e6b7b" to="/">{{
        $t("devices.Welcome")
      }}</router-link>
      > {{ $t("lcd.Devices.DevicesManage") }} >
      <span style="color: #3461ff">{{ $t("lcd.Devices.DevicesList") }}</span>
    </div>
    <div class="flex-between card-bg esls-page_top device-page_top">
      <div class="flex-between transmit-btn-box">
        <el-popover
          placement="bottom"
          title=""
          popper-class="esls-page_transmit-btn_el-popover"
          min-width="160"
          trigger="click"
        >
          <el-button
            style="display: normal"
            size="small"
            class="transmit-btn top-btn"
            slot="reference"
            :disabled="selectedData.length < 1"
            >{{ $t("lcd.Devices.Batch Operate") }}</el-button
          >
          <div class="transmit-select">
            <div
              class="transmit-select-item"
              v-for="item in lcdBatchOperation()"
              :key="item.value"
              @click="batchFun(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-popover>

        <el-popover
          placement="bottom"
          title=""
          popper-class="esls-page_transmit-btn_el-popover"
          min-width="160"
          trigger="click"
        >
          <el-button
            style="display: normal"
            size="small"
            class="transmit-btn top-btn"
            slot="reference"
            >{{ $t("lcd.Devices.Store Operate") }}</el-button
          >
          <div class="transmit-select">
            <div
              class="transmit-select-item"
              v-for="item in lcdStoreOperation()"
              :key="item.value"
              @click="storeFun(item.value)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="card-bg esls-page_content">
      <div class="esls-page_content-top flex-between">
        <div>
          <span>{{ $t("devices.records") }}: {{ pageParams.total }}</span>
          <el-select
            v-model="pageParams.storeType"
            :placeholder="$t('devices.esl.Store Type Select')"
            size="small"
            @change="storeTypeChange"
            style="width: 150px; margin-left: 10px"
          >
            <el-option
              v-for="(item, i) in storeTypeList()"
              :key="i"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <div>
          <button class="refresh" @click="handleRefresh" ref="btn">
            <i class="el-icon-refresh"></i>
          </button>
        </div>
      </div>
      <div class="esls-page_content-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-loading="tableLoading"
          @sort-change="handleSort"
        >
          <el-table-column align="center" type="selection">
            <el-table-column
              align="center"
              width="55"
              type="selection"
              style="display: none"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('lcd.Devices.Store Name')">
            <el-table-column prop="storeName" min-width="150">
              <template #header>
                <el-input
                  clearable
                  v-model="pageParams.storeName"
                  size="mini"
                  @input="regetList"
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('lcd.Devices.Device ID')" prop="code">
            <el-table-column prop="code" min-width="180">
              <template #header>
                <el-input
                  clearable
                  v-model="pageParams.code"
                  size="mini"
                  @change="regetList"
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('lcd.Devices.Signal Strength')"
            prop="signalStrength"
          >
            <el-table-column
              align="center"
              prop="signalStrength"
              min-width="120"
            >
              <template #header> </template>
              <template slot-scope="scope">
                <img
                  v-if="scope.row.signalStrength >= -35"
                  style="width: 28px; height: 20px"
                  src="@/assets/img/s1.png"
                />
                <img
                  v-if="
                    scope.row.signalStrength < -35 &&
                    scope.row.signalStrength >= -50
                  "
                  style="width: 28px; height: 20px"
                  src="@/assets/img/s2.png"
                />
                <img
                  v-if="scope.row.signalStrength < -50"
                  style="width: 28px; height: 20px"
                  src="@/assets/img/s3.png"
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('lcd.Devices.Resolution')" prop="pixels">
            <el-table-column prop="pixels" min-width="120">
              <template #header>
                <el-input
                  clearable
                  v-model="pageParams.pixels"
                  size="mini"
                  @input="regetList"
                />
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            :label="$t('lcd.Devices.Online State')"
            prop="onlineStateDesc"
          >
            <el-table-column prop="onlineStateDesc" width="120">
              <!-- TODO 在线状态的获取 -->
              <template #header>
                <el-select
                  v-model="pageParams.onlineState"
                  placeholder=""
                  size="mini"
                  clearable
                  @change="regetList"
                >
                  <el-option
                    v-for="item in onlineStateList"
                    :key="item.codeId"
                    :label="item.codeName"
                    :value="item.codeId"
                  />
                </el-select>
              </template>
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  v-if="scope.row.onlineState == 4201"
                  type="success"
                  >{{ scope.row.onlineStateDesc }}</el-tag
                >
                <el-tag size="mini" v-else type="danger">{{
                  scope.row.onlineStateDesc
                }}</el-tag>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column :label="$t('lcd.Devices.Bound Template')">
            <el-table-column prop="bindTemplateName" width="150">
              <!-- TODO 在线状态的获取 -->
              <template #header>
                <!-- <el-select
                  v-model="pageParams.state"
                  placeholder=""
                  size="mini"
                  clearable
                  @change="regetList"
                >
                  <el-option
                    v-for="item in bindState"
                    :key="item.codeId"
                    :label="item.codeName"
                    :value="item.codeId"
                  />
                </el-select> -->
              </template>
              <template slot-scope="scope">
                <span
                  style="color: #35b871; cursor: pointer"
                  @click="showScreenDisplay(scope.row)"
                >
                  {{
                    scope.row.bindTemplateName
                      ? JSON.parse(scope.row.bindTemplateName).templateName
                      : ""
                  }}
                  <i class="icon el-icon-search"></i>
                </span>

                <!-- <el-popover
                  placement="left"
                  :title="$t('lcd.Devices.Display Info')"
                  :width="
                    scope.row.installType == 5002 ||
                    scope.row.installType == 5004
                      ? 450
                      : 690
                  "
                  trigger="click"
                  v-if="scope.row.bindTemplateName"
                >
                  <div class="currentPreview">
                    <div
                      class="preview800"
                      v-if="
                        scope.row.installType == 5002 ||
                        scope.row.installType == 5004
                      "
                    >
                      <div
                        v-for="(item, index) in JSON.parse(
                          scope.row.bindTemplate
                        )"
                        :key="index"
                      >
                        <video
                          class="previewVideo"
                          v-if="item.type == 'video'"
                          :src="item.files[0].name"
                          :style="{
                            width: item.area.width / 2 + 'px',
                            height: item.area.height / 2 + 'px',
                            top: item.area.top / 2 + 'px',
                            left: item.area.left / 2 + 'px',
                            'z-index': item.area.height == 1280 ? 0 : 1,
                          }"
                          autoplay
                          loop
                        ></video>
                        <el-image
                          class="previewImg"
                          :style="{
                            width: item.area.width / 2 + 'px',
                            height: item.area.height / 2 + 'px',
                            top: item.area.top / 2 + 'px',
                            left: item.area.left / 2 + 'px',
                          }"
                          v-if="item.type == 'img'"
                          :src="item.files[0].name"
                          fit="contain"
                        ></el-image>
                      </div>
                    </div>
                    <div
                      class="preview1280"
                      v-if="
                        scope.row.installType == 5001 ||
                        scope.row.installType == 5003
                      "
                    >
                      <div
                        v-for="(item, index) in JSON.parse(
                          scope.row.bindTemplate
                        )"
                        :key="index"
                      >
                        <video
                          class="previewVideo"
                          v-if="item.type == 'video'"
                          :src="item.files[0].name"
                          :style="{
                            width: item.area.width / 2 + 'px',
                            height: item.area.height / 2 + 'px',
                            top: item.area.top / 2 + 'px',
                            left: item.area.left / 2 + 'px',
                            'z-index': item.area.height == 1280 ? 0 : 1,
                          }"
                          autoplay
                          loop
                        ></video>
                        <el-image
                          class="previewImg"
                          :style="{
                            width: item.area.width / 2 + 'px',
                            height: item.area.height / 2 + 'px',
                            top: item.area.top / 2 + 'px',
                            left: item.area.left / 2 + 'px',
                          }"
                          v-if="item.type == 'img'"
                          :src="item.files[0].name"
                          fit="contain"
                        ></el-image>
                      </div>
                    </div>
                  </div>
                  <el-button
                    type="text"
                    icon="el-icon-search"
                    slot="reference"
                  ></el-button>
                </el-popover> -->
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column :label="$t('lcd.Devices.Bound Item')">
            <el-table-column prop="bindItem" width="250">
              <!-- TODO 在线状态的获取 -->
              <template slot="header">
                <el-select
                  v-model="pageParams.state"
                  placeholder=""
                  size="mini"
                  clearable
                  @change="regetList"
                >
                  <el-option
                    v-for="item in bindState"
                    :key="item.codeId"
                    :label="item.codeName"
                    :value="item.codeId"
                  />
                </el-select>
              </template>
              <template slot-scope="scope">
                <div
                  class="itemListWrap"
                  v-for="(item, index) in JSON.parse(scope.row.bindItem)"
                  :key="index"
                >
                  <el-tag size="small">{{ item.itemCode }}</el-tag>
                  {{ item.itemName }}
                </div>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 设备分组标签 -->
          <el-table-column
            :label="$t('lcd.Devices.Device LabelType')"
            prop="labelTypeDesc"
          >
            <el-table-column prop="labelTypeDesc" width="120">
              <!-- TODO 在线状态的获取 -->
              <template #header>
                <el-select
                  v-model="pageParams.labelType"
                  placeholder=""
                  size="mini"
                  clearable
                  @change="regetList"
                >
                  <el-option
                    v-for="item in labelTypeList"
                    :key="item.codeId"
                    :label="item.codeName"
                    :value="item.codeId"
                  />
                </el-select>
              </template>
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.labelTypeDesc"
                  size="mini"
                  type="success"
                  >{{ scope.row.labelTypeDesc }}</el-tag
                >
                <i
                  style="
                    color: #35b871;
                    line-height: 23px;
                    float: right;
                    cursor: pointer;
                  "
                  class="el-icon-edit"
                  @click="changeLabelType(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            :label="$t('lcd.Devices.Delayed Info')"
            min-width="120"
            prop="netDelay"
          >
            <el-table-column prop="netDelay" min-width="120">
              <template #header> </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            :label="$t('lcd.Devices.Hardware Info')"
            min-width="130"
            prop="name"
            align="center"
          >
            <el-table-column align="center" prop="name" min-width="130">
              <template slot="header">
                <el-input
                  clearable
                  v-model="pageParams.name"
                  size="mini"
                  @input="regetList"
                />
              </template>
              <template slot="default" slot-scope="{ row }">
                {{ row.name }} <br />
                {{ row.osVersion }}
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            :label="$t('lcd.Devices.Update Time')"
            min-width="220"
            prop="updateTime"
            sortable="custom"
          >
            <el-table-column prop="updateTime" min-width="220">
              <template slot="header">
                <el-date-picker
                  clearable
                  v-model="pageParams.endTime"
                  type="daterange"
                  align="center"
                  size="mini"
                  class="intergation_picker"
                  unlink-panels
                  range-separator="-"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  style="width: 200px"
                  @change="regetList"
                />
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            fixed="right"
            :label="$t('images.Action')"
            width="220"
            header-align="center"
          >
            <el-table-column align="center" width="220">
              <template slot="header"></template>
              <template slot="default" slot-scope="{ row }">
                <div class="operate">
                  <span class="operateBtn" @click="handleBindItem(row)">
                    {{ $t("lcd.Devices.Bind Item") }}
                  </span>
                  <span class="operateBtn" @click="handleUnbind(row)">
                    {{ $t("lcd.Devices.Unbind") }}
                  </span>
                  <span class="operateBtn" @click="handleBindTemplate(row)">
                    {{ $t("lcd.Devices.Bind Template") }}
                  </span>
                  <br />
                  <el-tooltip class="item" placement="bottom">
                    <el-button type="text" class="moreBtn"
                      >{{ $t("lcd.Devices.More") }}
                      <i class="el-icon-arrow-down"></i
                    ></el-button>
                    <div class="tooltipContent" slot="content">
                      <span class="operateMoreBtn" @click="handleDetail(row)">
                        {{ $t("lcd.Devices.Detail") }}
                      </span>
                      <span
                        class="operateMoreBtn"
                        @click="handleSetInstallType(row)"
                      >
                        {{ $t("lcd.Devices.Install Type") }}
                      </span>
                      <span class="operateMoreBtn" @click="handleRepush(row)">
                        {{ $t("lcd.Devices.Repush") }}
                      </span>
                      <span class="operateMoreBtn" @click="handleHiberate(row)">
                        {{ $t("lcd.Devices.Hibernate") }}
                      </span>
                      <span class="operateMoreBtn" @click="handleWake(row)">
                        {{ $t("lcd.Devices.Wake") }}
                      </span>
                      <span class="operateMoreBtn" @click="handleRestart(row)">
                        {{ $t("lcd.Devices.Restart") }}
                      </span>
                      <span
                        class="operateMoreBtn"
                        @click="handleSetScreen(row,'brightness','single')"
                      >
                        {{ $t("lcd.Devices.Brightness set") }}
                      </span>
                      <span
                        class="operateMoreBtn"
                        @click="handleSetScreen(row,'volume','single')"
                      >
                        {{ $t("lcd.Devices.Volume set") }}
                      </span>
                      <span class="operateMoreBtn" @click="handleDelete(row)">
                        {{ $t("lcd.Devices.Delete") }}
                      </span>
                      
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <pagination :tableInfo="pageParams" @changePage="changePage" />
      </div>
    </div>

    <confirm-dialog
      :dialogVisible="isVisibleConfirmDialog"
      @handleClose="handelConfirmDialog"
      :confirmObj="confirmObj"
    >
    </confirm-dialog>

    <!-- 设备详情弹窗 -->
    <device-detail ref="deviceDetailRef" :detailData="detailData">
    </device-detail>

    <!-- 定时熄屏设置 -->
    <screen-setting
      ref="screenSettingRef"
      @reGetList="reGetList"
    ></screen-setting>

    <!-- 绑定商品弹窗 -->
    <BindItemDialog
      ref="bindItemRef"
      :detailData="detailData"
      :storeType="pageParams.storeType"
      @reGetList="reGetList"
    ></BindItemDialog>

    <!-- 绑定模板弹窗 -->
    <BindTemplate
      ref="bindTemplateRef"
      :detailData="detailData"
      :storeType="pageParams.storeType"
      @reGetList="reGetList"
    ></BindTemplate>

    <!-- 门店绑定模板弹窗 -->
    <StoreBindTemplate
      ref="storeBindTemplateRef"
      :storeType="pageParams.storeType"
      @reGetList="reGetList"
    ></StoreBindTemplate>

    <!-- 设置安装方式 -->
    <SetInstallType
      ref="setInstallTypeRef"
      :detailData="detailData"
      @reGetList="reGetList"
    ></SetInstallType>

    <!-- 门店屏幕当前展示内容预览 -->
    <ScreenDisplay
      ref="screenDisplayRef"
      :currentDisplayData="currentDisplayData"
    ></ScreenDisplay>

    <!-- 设置设备标签 -->
    <!-- setLabelTypeRef -->
    <setLabelType
      ref="setLabelTypeRef"
      :detailData="detailData"
      @reGetList="reGetList"
    ></setLabelType>

    <!-- 设置亮度和音量弹窗 -->
    <setScreen
      ref="setScreenRef"
      :detailData="detailData"
      :flag="setFlag"
      :type="setType"
      @reGetList="reGetList"
    ></setScreen>
  </div>
</template>
<script>
import BindItemDialog from "./components/bindItemDialog";
import UnbindDialog from "./components/unbindDialog";
import DeviceDetail from "./components/deviceDetail";
import ScreenSetting from "./components/screenSetting";
import BindTemplate from "./components/bindTemplate";
import StoreBindTemplate from "./components/bindTemplateStore";
import SetInstallType from "./components/setInstallType";
import ScreenDisplay from "./components/screenDisplay";
import SetLabelType from "./components/setLabelType";
import SetScreen from "./components/setScreen.vue";
import { commonStore } from "@/store/global-select-store";
import pagination from "@/components/pagination";
import ConfirmDialog from "@/components/confirm-dialog/index.vue";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import {
  getDeviceList,
  screenPhysicalDelete,
  screenBatchPhysicalDelete,
  screenDetail,
  screenTemplateBind,
  screenItemBind,
  screenItemUnbind,
  screenWake,
  screenSleep,
  screenRestart,
  screenRepush,
  storeScreenRepush,
  storeScreenSleep,
  storeScreenWake,
  storeScreenRestart,
  screenSetSingle,
  screenSetStore,
} from "@/libs/api/lcd";

import { batchPushTag, pushTagByType } from "@/libs/api/esls";
import {
  lcdBatchOperation, // lcd批量操作lis
  lcdStoreOperation,
  storeTypeList,
  paginationEnum,
} from "@/libs/enum";
export default {
  name: "ApsIndex",
  components: {
    BindItemDialog,
    UnbindDialog,
    DeviceDetail,
    ScreenSetting,
    pagination,
    ConfirmDialog,
    BindTemplate,
    StoreBindTemplate,
    SetInstallType,
    ScreenDisplay,
    SetLabelType,
    SetScreen,
  },
  data() {
    return {
      storeTypeList,
      lcdBatchOperation,
      lcdStoreOperation,
      bindState: [], // 绑定商品状态
      onlineStateList: [], // 在线离线状态
      labelTypeList: [], // 设备标签列表
      pageParams: {
        storeName: "",
        code: "", // 编号
        current: 1,
        size: 10,
        total: 0,
        storeType: 2,
        startDate: "",
        endDate: "",
        onlineState: "", // 在线状态
        state: "", // 绑定状态
        labelType: "", // 设备标签筛选
        orders: [],
        name: "", // 新增硬件版本检索字段
      },
      tableData: [],
      currentItem: {},
      selectedData: [],
      selectedDataCode: [],
      isVisibleConfirmDialog: false, //确认弹框
      isVisibleDetailDialog: false, // 设备详情弹窗
      detailData: {}, // 当前设备详情，弹窗信息
      isVisibleBindDialog: false, // 绑定弹窗
      confirmObj: {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("devices.esl.repushTips"),
        loading: false,
      },
      currentConfirmType: "",
      commonStore,
      paginationEnum,
      loading: false,
      tableLoading: false,

      isVisibleRecordsDialog: false,
      isVisibleDetailDialog: false, //详情
      isVisibleTransmitByApDialog: false, //AP推送
      isVisibleTransmitByEslDialog: false, //ESL推送
      tagIds: [],
      init: true, // 是否首次进入页面
      currentDisplayData: {}, // 当前预览屏幕data
      setFlag: '',
      setType: ''
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取页面列表数据
    // getList: debounce(async function (val) {
    //   // TODO
    //   getDeviceList(this.pageParams).then((res) => {
    //     console.log(res);
    //     this.tableData = res.data.data.records;
    //     this.pageParams.total = res.data.data.total;
    //   });
    // }, 300),
    getList() {
      this.tableLoading = true;
      const params = {
        ...this.pageParams,
        storeId:
          localStorage.getItem("storeId") == 1
            ? ""
            : localStorage.getItem("storeId"),
      };
      getDeviceList(params).then((res) => {
        console.log(res);
        this.tableLoading = false;
        this.tableData = res.data.data.records;
        this.pageParams.total = res.data.data.total;
      });
    },
    // 列表数据搜索
    regetList() {
      this.getList();
    },
    // 刷新
    handleRefresh() {
      this.tableLoading = true;
      this.getList();
    },
    changePage() {
      this.getList();
    },

    handleDetail(row) {
      const params = {
        screenId: row.id,
      };
      screenDetail(params).then((res) => {
        console.log(res);
        if (res.data.code == "1") {
          console.log(res);
          this.detailData = res.data.data;
          this.$refs.deviceDetailRef.open();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    batchFun(val) {
      // TODO
      console.log("一些批量操作方法");
      console.log(this.selectedData);
      // 选中的数据 selectedData
      if (val == "Batch delete") {
        const selectedDataCodeString = this.selectedDataCode.join(",");
        this.confirmObj.content = `${selectedDataCodeString}${this.$t(
          "lcd.Devices.Delete Tips"
        )}`;
        this.isVisibleConfirmDialog = true;
        this.currentConfirmType = "BatchDelete";
      }
    },

    // 门店级操作
    storeFun(val) {
      console.log("一些批量操作方法");
      if (val == "Store repush") {
        this.confirmObj.content = `${this.$t("lcd.Devices.Store repush tips")}`;
        this.isVisibleConfirmDialog = true;
        this.currentConfirmType = "StoreRepush";
      } else if (val == "Store restart") {
        this.confirmObj.content = `${this.$t(
          "lcd.Devices.Store restart tips"
        )}`;
        this.isVisibleConfirmDialog = true;
        this.currentConfirmType = "StoreRestart";
      } else if (val == "Store sleep") {
        this.confirmObj.content = `${this.$t(
          "lcd.Devices.Store hibernate tips"
        )}`;
        this.isVisibleConfirmDialog = true;
        this.currentConfirmType = "StoreSleep";
      } else if (val == "Store wake") {
        this.confirmObj.content = `${this.$t("lcd.Devices.Store wake tips")}`;
        this.isVisibleConfirmDialog = true;
        this.currentConfirmType = "StoreWake";
      } else if (val == "Store close") {
        this.$refs.screenSettingRef.open();
      } else if (val == "Store template") {
        this.$refs.storeBindTemplateRef.open();
      } else if (val == "Store brightness") {
        this.setFlag = 'brightness'
        this.setType = 'store'
        this.$refs.setScreenRef.open();
      } else if (val == "Store volume") {
        this.setFlag = 'volume'
        this.setType = 'store'
        this.$refs.setScreenRef.open();
      }
    },

    handleDelete(row) {
      this.confirmObj.content = `ID:${row.code},${this.$t(
        "lcd.Devices.Delete Tips"
      )}`;
      this.isVisibleConfirmDialog = true;
      this.currentConfirmType = "singleDelete";
      this.currentItem = row;
    },
    // 单个删除lcd屏
    doSingleDeleteConfirm() {
      const params = {
        screenId: this.currentItem.id,
      };
      screenPhysicalDelete(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("devices.deleteSuccess"));
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.confirmObj.loading = false;
      this.isVisibleConfirmDialog = false;
    },
    // 批量删除lcd屏
    doBatchDeleteConfirm() {
      const params = {
        screenIds: this.selectedData.join(","),
      };
      screenBatchPhysicalDelete(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("devices.deleteSuccess"));
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
      this.confirmObj.loading = false;
      this.isVisibleConfirmDialog = false;
    },
    // 门店类型切换
    storeTypeChange() {
      this.getList();
    },
    // 排序
    handleSort(column) {
      let arr = [];
      if (column.order) {
        let order = column.order === "ascending" ? "asc" : "desc";
        console.log(column.prop)
        let columnProp = ''
        if(column.prop == 'updateTime'){
          columnProp = 'update_time'
        }
        order = order + ":" + columnProp;
        arr.push(order);
      } else {
        arr = [];
      }
      this.pageParams.orders = arr;
      this.getList();
    },

    handelConfirmDialog(val) {
      console.log(val);
      if (val === "confirm") {
        const { currentConfirmType } = this;

        this.confirmObj.loading = true;
        console.log(currentConfirmType);
        if (currentConfirmType === "singleDelete") {
          // 单个lcd屏删除
          this.doSingleDeleteConfirm();
        }
        if (currentConfirmType === "BatchDelete") {
          // 批量删除lcd屏
          this.doBatchDeleteConfirm();
        }
        /**
         * // 门店级重推StoreRepush
         * // 门店级休眠StoreSleep
         * // 门店级唤醒StoreWake
         * // 门店级重启StoreRestart
         */
        if (
          currentConfirmType === "StoreRepush" ||
          currentConfirmType === "StoreSleep" ||
          currentConfirmType === "StoreWake" ||
          currentConfirmType === "StoreRestart"
        ) {
          this.doStoreConfirm(currentConfirmType);
        }
      } else {
        this.isVisibleConfirmDialog = false;
        this.confirmObj.loading = false;
      }
    },
    // 门店级操作
    async doStoreConfirm(val) {
      try {
        const params = {
          storeId: localStorage.getItem("storeId"),
          taskTerminal: 0,
        };

        let resData = null;
        if (val == "StoreRepush") {
          const { data } = await storeScreenRepush(params);
          resData = data;
        }
        if (val == "StoreSleep") {
          const { data } = await storeScreenSleep(params);
          resData = data;
        }
        if (val == "StoreWake") {
          const { data } = await storeScreenWake(params);
          resData = data;
        }
        if (val == "StoreRestart") {
          const { data } = await storeScreenRestart(params);
          resData = data;
        }
        if (resData.code == 1) {
          this.isVisibleConfirmDialog = false;
          this.confirmObj.loading = false;
          this.$message.success(this.$t("devices.operationSuccess"));
          this.getList();
        } else {
          this.confirmObj.loading = false;
          this.$message.error(resData.message);
        }
      } catch (err) {
        this.confirmObj.loading = false;
        const { message } = err;
        this.$message.error(message);
      }
    },
    // do selected批量推送
    async doTransmittBySelectedConfirm() {
      try {
        const params = {
          tagIds: this.tagIds.join(","),
        };
        const { data } = await batchPushTag(params);
        if (data.state === true) {
          this.isVisibleConfirmDialog = false;
          this.confirmObj.loading = false;
          this.$message.success(this.$t("devices.operationSuccess"));
          this.getList();
        } else {
          this.confirmObj.loading = false;
          this.$message.error(data.message);
        }
      } catch (err) {
        this.confirmObj.loading = false;
        const { message } = err;
        this.$message.error(message);
      }
    },
    // do根据价签类型批量推送
    async doTransmittByTypeConfirm() {
      try {
        const eslIds = this.$refs.byElsTypeTable.eslIds || [];
        const params = {
          tagTypeIdList: eslIds,
          storeId: localStorage.getItem("storeId"),
        };
        const { data } = await pushTagByType(params);
        if (data.state === true) {
          this.isVisibleConfirmDialog = false;
          this.isVisibleTransmitByEslDialog = false;
          this.confirmObj.loading = false;
          this.$message.success(this.$t("devices.operationSuccess"));
          this.getList();
        } else {
          this.confirmObj.loading = false;
          this.$message.error(data.message);
        }
      } catch (err) {
        this.confirmObj.loading = false;
        const { message } = err;
        this.$message.error(message);
      }
    },

    handleSelectionChange(data) {
      let selectedData = [];
      let selectedDataCode = [];
      data.forEach((item) => {
        selectedData.push(item.id);
        selectedDataCode.push(item.code);
      });
      this.selectedData = selectedData;
      this.selectedDataCode = selectedDataCode;
    },

    async getCodeList(type) {
      try {
        const { data } = await getCodeList({ cateId: type });
        if (data.state === true) {
          let arr = data.data || [];
          if (type == 42) {
            this.onlineStateList = arr; // 在线状态类型
          } else if (type == 43) {
            this.bindState = arr; // 绑定商品状态
          } else if (type == 35) {
            this.labelTypeList = arr; // 绑定商品状态
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },

    reGetList() {
      this.getList();
    },

    // TODO
    handleUnbind(row) {
      console.log("handleUnbind", row);
      this.$confirm(
        this.$t("lcd.Devices.Sure Unbind Info"),
        this.$t("Warehouse.tips"),
        {
          confirmButtonText: this.$t("Warehouse.sure"),
          cancelButtonText: this.$t("Warehouse.cancel"),
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const params = {
              sn: row.code,
              taskTerminal: "0",
            };
            const { data } = await screenItemUnbind(params);
            if (data.state === true) {
              this.$message.success(this.$t("Warehouse.operationSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          } catch (err) {
            const { message } = err;
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },

    handleBindItem(row) {
      console.log("handleBindItem", row);
      this.detailData = row;
      this.$refs.bindItemRef.open();
    },

    handleBindTemplate(row) {
      console.log("handleBindTemplate", row);
      this.detailData = row;
      this.$refs.bindTemplateRef.open();
    },

    handleSetInstallType(row) {
      console.log("handleSetInstallType", row);
      this.detailData = row;
      this.$refs.setInstallTypeRef.open();
    },

    // 修改设备标签
    changeLabelType(row) {
      console.log("changeLabelType", row);
      this.detailData = row;
      this.$refs.setLabelTypeRef.open();
    },

    // 设备唤醒
    handleWake(row) {
      console.log("handleWake", row);
      this.$confirm(
        this.$t("lcd.Devices.Wake Tips"),
        this.$t("Warehouse.tips"),
        {
          confirmButtonText: this.$t("Warehouse.sure"),
          cancelButtonText: this.$t("Warehouse.cancel"),
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const params = {
              sn: row.code,
              taskTerminal: "0",
            };
            const { data } = await screenWake(params);
            if (data.state === true) {
              this.$message.success(this.$t("Warehouse.operationSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          } catch (err) {
            const { message } = err;
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },

    // 设备休眠方法
    handleHiberate(row) {
      console.log("handleHiberate", row);
      const params = {
        sn: row.code,
        taskTerminal: "0",
      };
      screenSleep(params).then((res) => {
        console.log(res);
        if (res.data.state == true) {
          this.$message.success(this.$t("Warehouse.operationSuccess"));
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    handleRestart(row) {
      console.log("handleRestart", row);
      this.$confirm(
        this.$t("lcd.Devices.Restart Tips"),

        this.$t("Warehouse.tips"),
        {
          confirmButtonText: this.$t("Warehouse.sure"),
          cancelButtonText: this.$t("Warehouse.cancel"),
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const params = {
              sn: row.code,
              taskTerminal: "0",
            };
            const { data } = await screenRestart(params);
            if (data.state === true) {
              this.$message.success(this.$t("Warehouse.operationSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          } catch (err) {
            const { message } = err;
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },

    handleRepush(row) {
      console.log("handleRepush", row);
      this.$confirm(
        this.$t("lcd.Devices.Sure repush tips"),
        this.$t("Warehouse.tips"),
        {
          confirmButtonText: this.$t("Warehouse.sure"),
          cancelButtonText: this.$t("Warehouse.cancel"),
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const params = {
              sn: row.code,
              taskTerminal: "0",
            };
            const { data } = await screenRepush(params);
            if (data.state === true) {
              this.$message.success(this.$t("Warehouse.operationSuccess"));
              this.getList();
            } else {
              this.$message.error(data.message);
            }
          } catch (err) {
            const { message } = err;
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },

    showScreenDisplay(item) {
      console.log(item);
      console.log(this.$refs.screenDisplayRef);
      this.$refs.screenDisplayRef.open();
      this.currentDisplayData = item;
    },


    handleSetScreen(row,flag,type){
      console.log(row,flag,type);
      this.setFlag = flag
      this.setType = type ? type : ''
      this.detailData = row
      this.$refs.setScreenRef.open();
    }
  },

  created() {
    commonStore.setInjectCallBack(this.getList);
    this.getList();
    this.getCodeList(42); // 在线离线状态
    this.getCodeList(43); // 绑定商品状态
    this.getCodeList(35); // 设备分组标签
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    language(val) {
      if (val) this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.red-color {
  color: rgba(255, 30, 30, 1) !important;
}
.green-color {
  color: rgba(40, 192, 24, 1);
}
.flex_ {
  display: flex;
}
.flex-column-center {
  align-items: center;
}
.flex-row-center {
  justify-content: center;
}

.transmit-select {
  .transmit-select-item {
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    text-align: center;
  }
}
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.image-dialog {
  border-radius: 6px;
  .title {
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 20px;
    height: 60px;
    line-height: 60px;
    background: hsl(226deg 29% 17%);
    padding: 0 21px;
    border-radius: 6px;
  }
  .items {
    padding: 0 21px;
    .items-title {
      font-size: 16px;
      color: #ffffff;
      border-bottom: 1px solid #ffffff;
    }
    .item-table {
      .item-table-header {
        padding: 0 10px;
        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin: 10px 0;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        padding: 0 12px;
        div {
          width: 40%;
        }
      }
      .item-table-list {
        height: 32px;
        line-height: 32px;
        background: #6f799a;
        border-radius: 6px;
        padding: 10px;

        display: flex;
        // justify-content: space-between;
        align-items: center;
        margin-bottom: 2px;

        span {
          width: 40%;
        }
        .item-name {
          width: 55%;
        }
      }
    }

    .details {
      .title {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        background: #282f45;
        height: 20px;
        line-height: 20px;
        padding: 0;
        margin: 20px 0;
      }
      border-top: 1px solid rgba(54, 63, 92, 0.9);
      margin-top: 20px;
      .details-image {
        padding: 0 20px 20px;
        width: 100%;
      }
      .have-picture {
        height: auto;
        img {
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .no-picture {
        height: 200px !important;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .items-types {
      margin-bottom: 25px;
      .item-type {
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
}
.esls-page {
  .refresh {
    background: #35b871;
    border: none;
    padding: 7px 9px;
    border-radius: 4px;
    color: #fff;
  }
  .pointer {
    cursor: pointer;
  }
  .search-icon {
    width: 31px;
    height: 31px;
    background: #edfff5;
    border-radius: 16px;
    color: rgba(53, 184, 113, 1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flex-between {
    display: flex;
    justify-content: space-between;
  }
  .card-bg {
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
  }
  &_top ::v-deep {
    padding: 20px;
    margin-bottom: 20px;
    .right-btn,
    .transmit-btn-box {
      .el-button > span {
        // display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .el-button {
      width: 140px;
      // height: 40px;
      height: 34px;
      border-radius: 6px;
      // font-size: 18px;
      padding: 0 16px;
      color: #ffffff;
      i {
        margin-right: 5px !important;
      }
      .el-input {
        height: 100%;
        .el-input__inner {
          height: 100%;
        }
      }
    }
    // transmit下拉框
    .transmit-btn.el-button {
      border: none;
      margin-right: 20px;
      background: #3461ff;
      color: #ffffff;
      border-radius: 6px;
    }
    .danger-btn {
      background: #fc184d;
      color: #ffffff;
    }
    .gray-btn {
      background: #eeeeee;
      border: 1px solid #eeeeee;
      color: #666666;
      width: 80px;
    }
    .top-btn {
      width: 120px;
      text-align: center !important;
    }
  }
  &_content {
    &-top {
      padding: 15px;
      font-size: 12px;
      // color: #999999;
      > span {
        margin-right: 10px;
      }
    }
    &-table ::v-deep {
      .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            width: 100% !important;
          }
        }

        .el-table__header-wrapper,
        .el-table__empty-block {
          width: 100% !important;
        }
      }
      .el-table
        .el-table__header-wrapper
        .el-table__header
        .is-group
        tr:nth-of-type(2)
        th:nth-of-type(1)
        .cell {
        display: none;
      }
      .else-state {
        padding: 3px 18px;
        text-align: center;
        border-radius: 15px;
        display: inline-block;
      }
      .state-red {
        background: rgba(254, 202, 202, 1);
      }

      .state-blue {
        background: rgba(193, 233, 255, 1);
      }
    }
  }
  .dialog-footer ::v-deep {
    text-align: center;
    .el-button {
      width: 110px;
      height: 40px;
      border: none;
    }
    .el-button.cancel-btn {
      background: #d4d4d4 !important;
      box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
      color: #626262;
    }
    .el-button.save-btn {
      background: #35b871 !important;
      box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
      color: #ffffff;
    }
  }
  .communication-records_dialog ::v-deep {
    .el-dialog__body {
      padding: 30px 20px !important;
    }
  }
}

// lcdlist css
.operateBtn {
  font-size: 12px;
  color: #35b871;
  padding: 3px 8px;
  cursor: pointer;
}
.moreBtn {
  font-size: 12px;
  color: #35b871;
  cursor: pointer;
}
.tooltipContent {
  text-align: center;
}
.operateMoreBtn {
  display: block;
  font-size: 12px;
  color: #35b871;
  padding: 8px;
  text-align: center;
  cursor: pointer;
}
.itemListWrap {
  margin: 5px 0;
  padding: 3px 5px;
  border-radius: 4px;
  font-size: 12px;
  // background-color: #fff;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.preview800,
.preview1280 {
  width: 416px;
  height: 656px;
  border: 8px solid #333;
  border-radius: 10px;
  background-color: #333;
  position: relative;
  overflow: hidden;
}
.preview1280 {
  width: 656px;
  height: 416px;
}
.previewVideo,
.previewImg {
  position: absolute;
}
</style>